import { AbstractSseConnection } from './AbstractSseConnection';
import { LiveEventCountEvent } from '../types';
import { getConfig } from '@superbet-group/web.lib.config';

export class LiveEventsCountConnection extends AbstractSseConnection<number> {
    constructor() {
        // Live event count stayed on v1 offer api
        super('events/live/count', `${getConfig().sportsOffer?.sseUrl}/subscription`);
    }

    // eslint-disable-next-line class-methods-use-this
    public processSseEvents(events: LiveEventCountEvent[]): number {
        return events[events.length - 1].count;
    }
}
